<template>
  <div class="cupProduction">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="参考月份">
        <el-input v-model="searchForm.months" size="medium" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="生产指数">
        <el-input v-model="searchForm.P" size="medium" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="药杯型号">
        </el-table-column>
        <el-table-column
            prop="one"
            label="总药杯使用量">
        </el-table-column>
        <el-table-column
            prop="two"
            label="每月平均消耗量">
        </el-table-column>
        <el-table-column
            prop="there"
            label="建议生产量">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <!--    <div style="margin-top: 20px">-->
    <!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
    <!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import DicInput from "@/components/DicInput";

export default {
  name: "cupProduction",
  data() {
    return {
      tableData: [],
      srcList: [],
      doctor_count: '',
      searchForm: {
        months: '',
        P: '',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      dialogVisible: false,
      doctorDetails: ''
    }
  },
  components: {
    Pagination,
    DicInput
  },
  created() {
    this.GetOtherConfig = JSON.parse(window.utils.storage.getter("GetOtherConfig"))
    if (this.GetOtherConfig) {
      this.searchForm.months = this.GetOtherConfig.months
      this.searchForm.P = this.GetOtherConfig.p
    }
  },
  methods: {
    // -------------------查询条件/清空-------------------
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.searchForm.months = this.GetOtherConfig.months
      this.searchForm.P = this.GetOtherConfig.P
      this.init()
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        // page: this.currPage,
        // pageSize: this.pageSize,
      }
      delete data.loginTime
      this.axios
          .get("/Statistic/PFStatistic/GetCupProductionPlan", {params: data})
          .then((res) => {
            this.tableData = res
            this.tableData.forEach(item => {
              item.name = item.key
              item.value.forEach((key, index) => {
                switch (index) {
                  case 0:
                    item.one = key
                  case 1:
                    item.two = key
                    break;
                  case 2:
                    item.there = key
                    break;
                }
              })
            })
            console.log(this.tableData)
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.pecipeList {
  text-align: start;
  min-height: 800px;

  & > div:nth-child(1) {
    margin-bottom: 20px;

    .el-button {
      box-shadow: 0 4px 8px #FFE0BA;
    }
  }

  .decBox {
    padding-right: 20px;

    i {
      font-style: normal;
    }
  }

  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .doctorDetails {
    .titleName {
      font-weight: bold;
      padding-right: 10px;
    }

    .detailsLine {
      padding-bottom: 20px;
    }

    .tagList {
      margin-right: 10px;
    }
  }
}
</style>